import dedent from 'ts-dedent'
import {
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { SelectWorkflowComponent } from './common/selectcomponent'

class DistinctInColumn extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.distinct',
        group: 'Data Preparation',
        title: 'Select Distinct',
        description: `
      This component generates a new table with the unique values that appear in a given column of an input table.
      `,
        starred: true
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'column',
          type: WorkflowComponentParamType.Column,
          title: 'Column',
          parent: 'source'
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    if (connection.type === Provider.DatabricksRest) {
      return dedent`SELECT /*+ REPARTITION(40) */ DISTINCT ${params.column}
              FROM ${connection.quoteName(params.source as string)}`
    } else {
      return dedent`SELECT DISTINCT ${params.column}
              FROM ${connection.quoteName(params.source as string)}`
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ columns, params }: GetOutputSchemaParams): TableSchema {
    const column = columns.source.find((c) => c.name === params.column)
    if (!column) {
      return []
    }
    return [
      {
        name: params.column as string,
        type: column.type
      }
    ]
  }
  supportedProviders(): Provider[] {
    return [
      Provider.BigQuery,
      Provider.Postgres,
      Provider.Redshift,
      Provider.Snowflake,
      Provider.DatabricksRest,
      Provider.Oracle
    ]
  }
}

export { DistinctInColumn }
